module.exports = {
  title: "Jun.D",
  description: "Hello :) I'm Jun.D FrontEnd Developer",
  author: "JunYong",
  siteUrl: "https://jund-blog.netlify.app/",
  links: {
    github: "https://github.com/Junyong34",
    linkedIn: "https://www.linkedin.com/in/junD34",
    // facebook: "https://www.facebook.com",
    // instagram: "https://www.instagram.com",
    email: "mailto:wnsdyd21@gmail.com",
  },
  utterances: {
    repo: "Junyong34/jund-blog",
    type: "pathname",
  },
}






